import { BasePageComponent } from "../../shared/components/pages/BasePageComponent";

/** Ruta a la que se navega al entrar sin ninguna opción de menú. */
export const RUTA_SIN_PERMISOS = "/sin-permisos";

/**
 * Aviso para un usuario sin ningún rol (2026-10-07): el que se crea solo al entrar por el portal de Nitria
 * en Nitrofert. Sin esta página vería el menú vacío y la pantalla en blanco. Un administrador le asigna los
 * roles en Usuarios; el Server le rechaza toda función mientras tanto.
 */
export class SinPermisosPage extends BasePageComponent {
  public getAppRoute(): string { return RUTA_SIN_PERMISOS; }
  public getPageTitle(): string | null { return null; }

  /** Pinta el aviso centrado, con el estilo global de estado vacío. */
  protected override renderPageContent(pageContent: HTMLDivElement): void {
    pageContent.innerHTML = `
      <div class="sx-empty">
        <i class="ph ph-lock-key" aria-hidden="true" style="font-size:40px;margin-bottom:12px"></i>
        <div style="font-size:var(--sx-text-lg);font-weight:var(--sx-weight-bold);color:var(--sx-text-primary);margin-bottom:6px">
          Tu usuario no tiene permisos todavía
        </div>
        <div>Pide a un administrador que te los asigne.</div>
      </div>
    `;
  }
}
